import { createFileRoute, redirect } from "@tanstack/react-router"
import { useAuthStore } from "@/store/auth.store"
import { RfqDetailsPage as BuyerRfqDetailsPage } from "@/components/dashboard/buyer/pages/rfqs/RfqDetailsPage"
import { RfqDetailsPage as SellerRfqDetailsPage } from "@/components/dashboard/seller/pages/rfqs/RfqDetailsPage"
import { RfqDetailsPage as AdminRfqDetailsPage } from "@/components/dashboard/admin/pages/rfqs/RfqDetailsPage"

export const Route = createFileRoute("/rfqs/$rfqId")({
  beforeLoad: ({ params }) => {
    const { user } = useAuthStore.getState()
    const role = user?.role?.toUpperCase()
    if (role === "BUYER") {
      throw redirect({
        to: "/dashboard/quotations/$rfqId",
        params: { rfqId: params.rfqId },
      })
    }
  },
  validateSearch: (search: Record<string, unknown>): { subTab?: "buyers" | "sellers" } => ({
    subTab: (search.subTab as "buyers" | "sellers") || undefined,
  }),
  component: RfqDetailRoute,
})

function RfqDetailRoute() {
  const { rfqId } = Route.useParams()
  const { subTab } = Route.useSearch()
  const role = useAuthStore((s) => s.user?.role)
  if (role === "SELLER") return <SellerRfqDetailsPage rfqId={rfqId} />
  if (role === "ADMIN") return <AdminRfqDetailsPage rfqId={rfqId} subTab={subTab || "buyers"} />
  return <BuyerRfqDetailsPage rfqId={rfqId} />
}
